import { Icons, LoadingIndicator } from '@commenda/kakashi';
import { classNames } from '@commenda/utils';
import { ChangelogEntry } from './types';

export function ListView({
  changelogs,
  isLoading,
  onSelect,
}: {
  changelogs: ChangelogEntry[];
  isLoading: boolean;
  onSelect: (entry: ChangelogEntry) => void;
}) {
  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="pb-2">
        <span className="txt-extra-small-regular text-text-tertiary">
          What&apos;s new
        </span>
      </div>

      {/* List */}
      {isLoading ? (
        <div className="flex items-center justify-center py-4">
          <LoadingIndicator size={16} />
        </div>
      ) : changelogs.length === 0 ? (
        <div className="py-4 text-center">
          <span className="txt-extra-small-regular text-text-tertiary">
            No updates yet
          </span>
        </div>
      ) : (
        <div className="flex flex-col">
          {changelogs.map((entry, idx) => {
            const isFirst = idx === 0;
            const isLast = idx === changelogs.length - 1;
            return (
              <button
                key={entry.id}
                type="button"
                className="w-full text-left cursor-pointer flex items-stretch px-2 rounded hover:bg-bg-active-light transition-colors"
                onClick={() => onSelect(entry)}
              >
                {/* Stepper column: top line + dot + bottom line */}
                <div className="flex flex-col items-center shrink-0 ml-[2px] mr-[14px]">
                  <div
                    className="w-px flex-1"
                    style={{
                      backgroundColor: isFirst
                        ? 'transparent'
                        : 'var(--color-border-primary)',
                    }}
                  />
                  <div className="relative flex shrink-0 size-2">
                    {isFirst && (
                      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-fg-brand" />
                    )}
                    <span
                      className={classNames(
                        'relative inline-flex rounded-full size-2',
                        isFirst
                          ? 'bg-fg-brand ring-1 ring-fg-brand'
                          : 'bg-bg-primary drop-shadow-sm ring-1 ring-black/15'
                      )}
                    />
                  </div>
                  <div
                    className="w-px flex-1"
                    style={{
                      backgroundColor: isLast
                        ? 'transparent'
                        : 'var(--color-border-primary)',
                    }}
                  />
                </div>
                <span className="txt-extra-small-medium text-text-primary truncate py-1.5">
                  {entry.title}
                </span>
              </button>
            );
          })}

          {/* All updates link */}
          <button
            type="button"
            className="w-full text-left cursor-pointer flex items-center px-2 py-1.5 rounded hover:bg-bg-active-light transition-colors"
            onClick={() => {
              window.open(
                'https://commenda.productlane.com/changelog',
                '_blank',
                'noopener,noreferrer'
              );
            }}
          >
            <span className="ml-[2px] mr-[14px] shrink-0 size-2" />
            <span className="txt-extra-small-medium text-text-tertiary truncate flex items-center gap-1">
              All updates
              <Icons.ArrowUpRight className="size-3" />
            </span>
          </button>
        </div>
      )}
    </div>
  );
}
